import { useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFilterValueText } from '../../../utils/helpers/filters'
import ChecklistsFilterSideModal from './ChecklistsFilterSideModal'
import FilterLink from '../../../components/filter/FilterLink'
import FilterListItem from '../../../components/list/FilterListItem'
import Link from '../../../packages/kiti/components/actions/Link'

const ChecklistsFilter = ({ label, field, icon, presentation, ...props }) => {
  const { t } = useTranslation('checklists')
  const [open, setOpen] = React.useState(false)

  presentation = presentation || 'bar'
  label = label || t('checklist')
  field = field || 'checklistIds'
  const value = useFilterValue(field, [])

  const selectedValue = useFilterValueText(field)
  const Link = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <Link
        icon={presentation === 'bar' && (icon || 'RiListCheck2')}
        label={label}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <ChecklistsFilterSideModal open={open} onClose={() => setOpen(false)} label={label} field={field} {...props} />
    </>
  )
}

export default ChecklistsFilter
